import React from "react";

import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { listDepot, getpdf, telechargerPDF } from "../../actions/depotActions";
import { useNavigate } from "react-router-dom";

import PDF from "../../components/Pdf";

import Navbar2 from "../../components/navbars/Navbar2";
import Message from "../../components/Message";
import CircularProgress from "@mui/material/CircularProgress";
import { PDF_RESET } from "../../constants/depot_constant";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { Divider } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

// icon
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import StarIcon from "@mui/icons-material/Star";
import CloseIcon from "@mui/icons-material/Close";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CheckIcon from "@mui/icons-material/Check";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { styled } from "@mui/material/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import { orange } from "@mui/material/colors";
import { green } from "@mui/material/colors";
import { grey } from "@mui/material/colors";

export default function PatientDashboard() {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const [askDepotId, setaskDepotId] = useState();
  const [pdfpageNotification, setpdfpageNotification] = useState();

  const userLogin = useSelector((state) => state.userLogin);
  const { loading, error, userInfo } = userLogin;
  const depotList = useSelector((state) => state.depotList);
  const { loading: loadingD, error: errorD, depots } = depotList;
  const pdfPage = useSelector((state) => state.pdfPage);
  const { pdf } = pdfPage;

  // functions
  useEffect(() => {
    if (userInfo) {
      dispatch(listDepot(userInfo.ID_PATIENT));
      // console.log("useEffect", userInfo.ID_DEPOT);
      // askIdDepot(
      //   userInfo.ID_DEPOT,
      //   userInfo.SAISIE,
      //   userInfo.VALIDE,
      //   userInfo.DEPOTS_ANALYSES_VALIDE,
      //   userInfo.RESTE,
      //   userInfo.NBRE_PARAMETRE === userInfo.NBRE_PARAMETRE_SIGNE,
      //   userInfo.RESTE_PAYER_AUTORISE_IMPRESSION,
      //   userInfo.RESTE_PAYER_AUTORISE_IMPRESSION
      // );
    }
  }, [userInfo, dispatch]);

  useEffect(() => {
    console.log("askDepotId Effect", askDepotId);
  }, [askDepotId]);

  const askIdDepot = (
    id,
    saisie,
    valide,
    depot_valide,
    reste,
    paramValide,
    restAutorise,
    autoriseRest
  ) => {
    // console.log("askIdDepot function", id);
    if (saisie === "N" && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("Dossie non saisi");
    } else if (saisie === "P" && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("Dossier Partiellement saisi");
    } else if (valide === "N" && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("Dossier non validé techniquement");
    } else if (valide === "P" && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("Dossier Partiellement validé");
    } else if (
      depot_valide === "N" &&
      restAutorise !== "O" &&
      autoriseRest !== "O"
    ) {
      setpdfpageNotification(" Dossier non signé");
    } else if (!paramValide && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("Dossier Pariellement signé");
    } else if (reste != 0 && restAutorise !== "O" && autoriseRest !== "O") {
      setpdfpageNotification("pour voir le résultat veuillez payer la facture");
    } else {
      setpdfpageNotification(false);
    }
    dispatch(getpdf(id));
    setaskDepotId(id);
  };

  // frontend
  const theme = createTheme({
    palette: {
      background: {
        default: "red",
      },
    },
  });

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  // state
  const titleOfState = (state, titles) => {
    switch (state) {
      case "O":
        return titles[0];
      case "P":
        return titles[1];
      case "N":
        return titles[2];
      case "A":
        return titles[3];
      default:
        return "";
    }
  };

  const colorOfState = (state) => {
    switch (state) {
      case "O":
        return green[700];
      case "P":
        return orange[700];
      case "N":
        return red[700];
      case "A":
        return grey[700];
      default:
        return "";
    }
  };

  function Items(props) {
    return (
      <div sx={{ overflowX: "scroll" }}>
        <Tooltip
          placement="top"
          title={titleOfState(props.saisie, [
            "Complètement saisi",
            "Partiellement saisi",
            "Non saisi",
          ])}
        >
          <TextSnippetIcon sx={{ color: colorOfState(props.saisie) }} />
        </Tooltip>
        <Tooltip
          placement="top"
          title={titleOfState(props.valide, [
            "Validé techniquement",
            "Partiellement validé",
            "Non validé techniquement",
          ])}
        >
          <StarIcon sx={{ color: colorOfState(props.valide) }} />
        </Tooltip>
        <Tooltip
          placement="top"
          title={
            props.depotValid === "N"
              ? "Non signé"
              : props.nbrParamS === props.nbrParam
              ? "Signé"
              : "Pariellement signé"
          }
        >
          {props.depotValid === "O" ? (
            <CheckIcon sx={{ color: colorOfState(props.depotValid) }} />
          ) : (
            <CloseIcon
              sx={{
                color: red[500],
              }}
            />
          )}
        </Tooltip>
        <Tooltip
          placement="top"
          title={
            props.rest !== 0
              ? "reste à payer :" + props.rest + "DA"
              : "Le paiement a été réglé"
          }
        >
          <MonetizationOnIcon
            sx={{
              color: props.rest === 0 ? green[500] : red[500],
            }}
          />
        </Tooltip>
      </div>
    );
  }
  return (
    <Navbar2>
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xl">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Grid item md={4} xs={12}>
              <Divider sx={{ marginY: 1 }}>
                <Chip label="Liste des dossiers" />
              </Divider>
              {/* <Box sx={{ display: "flex", justifyContent: "center" }}>
                  {" "}
                  <FormControlLabel
                    label="Parent"
                    control={
                      <Checkbox
                      // checked={false}
                      // indeterminate={true}
                      // onChange={handleChange1}
                      />
                    }
                  />
                  <FormControlLabel
                    label="Parent"
                    control={
                      <Checkbox
                      // checked={false}
                      // indeterminate={true}
                      // onChange={handleChange1}
                      />
                    }
                  />
                  <FormControlLabel
                    label="Parent"
                    control={
                      <Checkbox
                      // checked={false}
                      // indeterminate={true}
                      // onChange={handleChange1}
                      />
                    }
                  />
                </Box> */}
              <Paper>
                <Box
                  sx={{
                    boxShadow: 5,
                    mb: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: 550,
                    maxHeight: 550,
                    overflow: "hidden",
                    overflowY: "scroll",
                  }}
                >
                  <List>
                    {loadingD ? (
                      <CircularProgress />
                    ) : errorD ? (
                      <Message variant="error">{errorD}</Message>
                    ) : (
                      Object.values(depots).map((depot, i) => (
                        <div key={i}>
                          <ListItem
                            button
                            onClick={(e) =>
                              navigate(
                                "/resultat/" +
                                  depot.ID_DEPOT +
                                  "/" +
                                  depot.SAISIE +
                                  "/" +
                                  depot.VALIDE +
                                  "/" +
                                  depot.DEPOTS_ANALYSES_VALIDE +
                                  "/" +
                                  depot.RESTE +
                                  "/" +
                                  (depot.NBRE_PARAMETRE ===
                                    depot.NBRE_PARAMETRE_SIGNE) +
                                  "/" +
                                  depot.RESTE_PAYER_AUTORISE_IMPRESSION +
                                  "/" +
                                  (depot.AUTORISE_IMPRESSION_RESTE_PAYER ==
                                    null ||
                                  depot.AUTORISE_IMPRESSION_RESTE_PAYER == ""
                                    ? false
                                    : depot.AUTORISE_IMPRESSION_RESTE_PAYER)
                              )
                            }
                            sx={{
                              bgcolor:
                                depot.ID_DEPOT == askDepotId ? grey[200] : null,
                            }}
                          >
                            <Grid container>
                              <Grid item md={10}>
                                <ListItemText
                                  primary={
                                    "Déposé le " +
                                    depot.DATE_DEPOT_DEMANDE +
                                    " (" +
                                    depot.PERIODE_DEPOT_DEMANDE +
                                    ")"
                                  }
                                />
                                <ListItemText
                                  primary="."
                                  secondary={depot.LISTE_ABREGE_PARAMETRE}
                                />
                              </Grid>
                              <Grid item md={2}>
                                <ListItemText
                                  sx={{ textAlign: "right" }}
                                  primary={
                                    <Items
                                      key={depot.ID_DEPOT}
                                      saisie={depot.SAISIE}
                                      valide={depot.VALIDE}
                                      depotValid={depot.DEPOTS_ANALYSES_VALIDE}
                                      nbrParam={depot.NBRE_PARAMETRE}
                                      nbrParamS={depot.NBRE_PARAMETRE_SIGNE}
                                      rest={parseInt(depot.RESTE)}
                                    />
                                  }
                                />
                              </Grid>
                            </Grid>
                          </ListItem>
                          <Divider />
                        </div>
                      ))
                    )}
                  </List>
                </Box>
              </Paper>
              {/* <Grid item md={8} xs={12}>
                <Divider sx={{ marginY: 1 }}>
                  <Chip label="Résultat à visualiser" />
                </Divider>
                <Box sx={{ display: "flex", justifyContent: "end ", mb: 1 }}>
                  <Button
                    color="success"
                    variant="contained"
                    href={
                      "http://" +
                      window.location.hostname +
                      "/core/pdfPatient.php?id=" +
                      askDepotId
                    }
                    target="_blank"
                    // onClick={(e) => printPdf(askDepotId)}
                    startIcon={<DownloadForOfflineIcon />}
                  >
                    Télécharge les résultats
                  </Button>
                </Box>
                <Paper>
                  <Box
                    sx={{
                      p: 6,
                      mb: 2,
                      height: 500,
                      maxHeight: 500,
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                      overflowY: "scroll",
                      bgcolor: "#fff",
                      boxShadow: 5,
                    }}
                  >
                    {!pdfpageNotification ? (
                      <PDF pdf={pdf} />
                    ) : (
                      <Message variant="error">{pdfpageNotification}</Message>
                    )}
                  </Box>
                </Paper>
              </Grid> */}
            </Grid>
          </Box>
        </Container>
      </ThemeProvider>
    </Navbar2>
  );
}
